import "../../styles/HomeNew.css";

const ACTIVITIES = [
  {
    title: "Talent Show",
    emoji: "🎤",
    color: "card--purple",
    chipClass: "lchip--purple",
    badge: "Register Now",
    detail: "Deadline is July 13th",
    href: "https://www.zeffy.com/en-US/ticketing/kite-fest--2026",
    cta: "Registration Form →",
  },
  {
    title: "STEAM Race",
    emoji: "🔬",
    color: "card--pink",
    chipClass: "lchip--pink",
    badge: "Early Bird",
    detail: "Early bird offer ends June 30th",
    href: "https://www.zeffy.com/en-US/ticketing/kite-fest-2026-steam-race",
    cta: "Registration Form →",
  },
  {
    title: "Volunteer Opportunities",
    emoji: "🎮",
    color: "card--green",
    chipClass: "lchip--green",
    badge: "Help Out",
    detail: "Help us run a smooth event and make a big impact in our community. We have roles for all ages and skill sets, from setup to cleanup and everything in between.",
    href: "https://www.signupgenius.com/go/4090F4EA4A72AA2FB6-63948717-kite#/",
    cta: "Join the Team →",
  },
];

export default function KiteFest() {
  return (
    <div className="pg">



      {/* ── ACTIVITIES ── */}
      <section id="activities" className="events" style={{ maxWidth: "var(--max)", marginInline: "auto" }}>
        <div className="sec-hd">

          <h2 className="sec-h2">Kite Fest 2026 - Activities</h2>

          <p className="sec-sub">Something for everyone — come join the fun and support a great cause.</p>
        </div>
        <div className="events__grid">
          {ACTIVITIES.map(act => (
            <div key={act.title} className={`ecard ${act.color}`} style={{ cursor: act.href ? "pointer" : "default" }}>
              <div className="ecard__icon">{act.emoji}</div>
              <div className="ecard__img" style={{
                display: "flex", alignItems: "center", justifyContent: "center",
                background: act.color === "card--purple" ? "var(--pu-200)"
                  : act.color === "card--pink" ? "var(--pk-200)" : "var(--gn-200)",
                fontSize: "4rem",
              }}>
                {act.emoji}
              </div>
              <span className="ecard__label">{act.badge}</span>
              <h3 className="ecard__name">{act.title}</h3>
              <p className="ecard__desc">{act.detail}</p>
              {act.href
                ? <a href={act.href} target="_blank" rel="noopener noreferrer" className="ecard__arrow">{act.cta}</a>
                : <span className="ecard__arrow" style={{ opacity: .5 }}>{act.cta}</span>
              }
            </div>
          ))}
        </div>
      </section>


      {/* ── QUOTE BAND ── */}
      <div className="quote-band">
        <p>"Our mission is to promote social justice by meeting needs in the local community and the world through accountable, sustainable philanthropy and by nurturing future generations of servant leaders."</p>
      </div>

    </div>
  );
}